<template>
  <div
    v-if="screenWidth < 600"
    class="mobile-active-filters"
    :class="{ 'show' : showNav }"
  >
    <nav>
      <FilterButtons
        @cancelActiveFiltersForm="cancelActiveFiltersForm"
        @resetActiveFilters="resetActiveFilters"
        @saveActiveFilters="saveActiveFilters"
      />
      <UserFilters
        :isDesktop="false"
        :projectFilters="projectFilters"
        :userFilters="updatedActiveFilters"
        @updateUserFilters="updateActiveFilters"
      />
    </nav>
    <div class="overlay"></div>
  </div>

  <div
    class="dialog"
    v-else-if="screenWidth >= 600 && showNav"
  >
    <div class="card">
      <h1>Filters</h1>
      <UserFilters
        :isDesktop="true"
        :projectFilters="projectFilters"
        :userFilters="updatedActiveFilters"
        @updateUserFilters="updateActiveFilters"
      />
      <FilterButtons
        @cancelActiveFiltersForm="cancelActiveFiltersForm"
        @resetActiveFilters="resetActiveFilters"
        @saveActiveFilters="saveActiveFilters"
      />
    </div>
  </div>
</template>

<script>
import UserFilters from '@/components/user/UserFilters';
import FilterButtons from '@/components/form-elements/FilterButtons';

export default {
  name: 'ActiveFilters',
  props: {
    showNav: {
      type: Boolean
    },
    projectFilters: {
      type: Array
    },
    activeFilters: {
      type: Array
    }
  },
  components: {
    FilterButtons,
    UserFilters
  },
  data() {
    return {
      updatedActiveFilters: JSON.parse(JSON.stringify(this.activeFilters)),
      screenWidth: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getScreenWidth)
      this.getScreenWidth()
    })
  },
  methods: {
    getScreenWidth() {
      this.screenWidth = document.documentElement.clientWidth
    },
    cancelActiveFiltersForm() {
      this.$emit('hideNav')
      this.updatedActiveFilters = JSON.parse(JSON.stringify(this.activeFilters))
    },
    resetActiveFilters() {
      this.updatedActiveFilters = []
    },
    updateActiveFilters(activeFilters) {
      this.updatedActiveFilters = activeFilters
    },
    saveActiveFilters() {
      this.$emit('saveActiveFilters', this.updatedActiveFilters)
      this.$emit('hideNav')
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getScreenWidth)
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/nav';
@import '../../assets/styles/dialog';
@import '../../assets/styles/card';

.mobile-active-filters {

  nav {
    position: fixed;
    right: -80%;
    left: auto;
    padding: 16px;
  }

  &.show {

    nav {
      right: 0
    }

    .overlay {
      display: block;
    }
  }

  .user-filters {
    border-bottom: none;
  }

  @media (min-width: 600px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/ActiveFilters.vue